import { useState } from 'react';
import { Badge, Button, Container, Nav, Navbar } from 'react-bootstrap';
import './App.css';
import RequestDemoModal from './RequestDemoModal';
import BusinessesModal from './BusinessesModal';
import HaveAQuestionModal from './HaveAQuestionModal';
import RaiseTicketModal from './RaiseTicketModal';
import TeamModal from './TeamModal';
import SearchExperience from './SearchExperience';
import TrendingDiscovery from './TrendingDiscovery';
import { verticals } from './catalog';

// The homepage's two display groups - actual item-rental businesses vs. other (subscription-
// style) services. Everything else (search, trending, lookups) still uses the flat `verticals`.
const rentalVerticals = verticals.filter((v) => v.category === 'rental');
const otherServices = verticals.filter((v) => v.category === 'service');

const values = [
  'Unified catalog and inventory management',
  'Secure checkout, deposit, and insurance handling',
  'Responsive experiences across web and mobile',
];

function App() {
  const [showDemo, setShowDemo] = useState(false);
  // homepage_refactor.md - "Have a question?" is now a popup (HaveAQuestionModal), same treatment
  // as "Request a demo", instead of scrolling to an inline contact section.
  const [showQuestion, setShowQuestion] = useState(false);
  // v9 customer_support_tickets - "Raise a ticket" lives in the footer's Customer support section.
  const [showTicket, setShowTicket] = useState(false);
  // homepage_refactor.md - the "Businesses" grid + "Other services" grid are now one popup
  // (BusinessesModal), opened from the nav / hero / teaser strip rather than shown inline.
  const [showBusinesses, setShowBusinesses] = useState(false);
  // "Our Team" - the company story, roles/hierarchy and the people, as a popup (same pattern as
  // "Businesses" and "Contact").
  const [showTeam, setShowTeam] = useState(false);
  const openBusiness = (url) => {
    window.location.href = url;
  };

  return (
    <div className="rv-shell">
      <Navbar bg="dark" variant="dark" expand="lg" fixed="top">
        <Container>
          <Navbar.Brand href="/">RentalVerse</Navbar.Brand>
          <Navbar.Toggle />
          <Navbar.Collapse className="justify-content-end">
            <Nav>
              <Nav.Link href="#trending">Trending</Nav.Link>
              {/* homepage_refactor.md - "Businesses" (item-rental verticals) and "Other services"
                  (gym) now open the SAME popup instead of scrolling to two separate sections. */}
              <Nav.Link as="button" className="btn btn-link nav-link" onClick={() => setShowBusinesses(true)}>
                Businesses
              </Nav.Link>
              <Nav.Link as="button" className="btn btn-link nav-link" onClick={() => setShowTeam(true)}>
                Our Team
              </Nav.Link>
              {/* homepage_refactor.md - "Contact" opens the same "Have a question?" popup as the
                  hero/footer buttons, rather than scrolling to an inline section. */}
              <Nav.Link as="button" className="btn btn-link nav-link" onClick={() => setShowQuestion(true)}>
                Contact
              </Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <header className="rv-hero">
        <Container>
          {/* global_search_experience.md - one search box across every vertical, with a right-side
              filter panel (price / rating / category / sort) and a full-screen results overlay on
              mobile. */}
          <SearchExperience />
        </Container>
      </header>

      <main>

        {/* homepage_refactor.md - the old two grids (rental businesses / other services) are now
            ONE popup (BusinessesModal), which also carries each business's "About this business"
            (registration, experience, management team). No per-vertical tiles here - just the
            entry point into that popup. */}
        <TrendingDiscovery />

        <section className="rv-trust-message py-5">
          <Container>
            <Badge bg="light" text="dark" className="mb-3">Trusted rental experiences</Badge>
            <p className="lead mb-0">Discover homes, mobility, hospitality escapes, and luxury jewellery rentals from one unified platform.</p>
          </Container>
        </section>

        <section className="py-5">
          <Container>
            <h2 className="mb-4">Why RentalVerse</h2>
            <ul className="rv-value-list">
              {values.map((value) => (
                <li key={value}>✓ {value}</li>
              ))}
            </ul>
            <div className="d-flex flex-wrap gap-2">
              <Button variant="light" size="sm" onClick={() => setShowDemo(true)}>Request a business demo</Button>
              <Button variant="outline-secondary" size="sm" onClick={() => setShowTeam(true)}>Meet the team</Button>
            </div>
          </Container>
        </section>

      </main>

      <footer className="rv-footer">
        <Container className="d-flex justify-content-between align-items-start flex-wrap gap-3">
          <span>Launch your next rental business with confidence.</span>
          <div className="d-flex flex-column align-items-end gap-2">
            <div className="d-flex flex-column align-items-end">
              <span className="text-uppercase small opacity-75">Customer support</span>
              <div className="d-flex flex-wrap gap-2 mt-1">
                <Button variant="outline-light" size="sm" onClick={() => setShowTicket(true)}>Raise a ticket</Button>
                <Button variant="outline-light" size="sm" onClick={() => setShowQuestion(true)}>Have a question?</Button>
              </div>
            </div>
            <div className="d-flex flex-wrap gap-2">
              <Button
                variant="outline-light" size="sm"
                href={`${process.env.REACT_APP_CAR_RENTAL_URL || 'http://localhost:5174'}/register-cab`}
              >
                List your cab
              </Button>
              <Button variant="dark" onClick={() => setShowDemo(true)}>
                Request demo
              </Button>
            </div>
          </div>
        </Container>
      </footer>
      <RequestDemoModal show={showDemo} onHide={() => setShowDemo(false)} />
      <HaveAQuestionModal show={showQuestion} onHide={() => setShowQuestion(false)} />
      <RaiseTicketModal show={showTicket} onHide={() => setShowTicket(false)} />
      <TeamModal show={showTeam} onHide={() => setShowTeam(false)} />
      <BusinessesModal
        show={showBusinesses}
        onHide={() => setShowBusinesses(false)}
        rentalVerticals={rentalVerticals}
        otherServices={otherServices}
        openBusiness={openBusiness}
      />
    </div>
  );
}

export default App;
